(function () {
    'use strict';

    angular
        .module('trainingSchedule')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('trainingSchedule', {
                sticky: true,
                url: '/training-schedule',
                views: {
                    'trainingScheduleView': {
                        templateUrl: 'training-schedule/views/training-schedule.tpl.html',
                        controller: 'TrainingScheduleCtrl',
                        controllerAs: 'trainingSchedule'
                    }
                }
            });
    }
}());
